import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, FlameIcon } from 'lucide-react';
import { Avatar } from '../components/ui/Avatar';
import { MOCK_USERS, MOCK_VIDEOS, MOCK_CATEGORIES } from '../data/mockData';
export function Discover() {
  const navigate = useNavigate();
  const TRENDING_HASHTAGS = ['comedy', 'standup', 'pranks', 'dadjokes', 'office', 'relatable'];
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-334">
      {/* Header & Search Bar */}
      <div className="px-4 pt-6 pb-4 sticky top-0 bg-black/90 backdrop-blur-md z-10" data-id="element-335">
        <button onClick={() => navigate('/search')} className="w-full bg-surface border border-border rounded-xl px-4 py-3 flex items-center gap-3 text-softGray cursor-text" data-id="element-336">
          <SearchIcon size={20} data-id="element-337" />
          <span className="text-sm" data-id="element-338">Search creators, videos, hashtags...</span>
        </button>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar pb-6" data-id="element-339">
        {/* Trending Hashtags */}
        <div className="mb-8" data-id="element-340">
          <div className="px-4 flex items-center gap-2 mb-4" data-id="element-341">
            <FlameIcon className="text-neonOrange" size={20} data-id="element-342" />
            <h2 className="text-white font-poppins font-bold text-lg" data-id="element-343">
              Trending Hashtags
            </h2>
          </div>
          <div className="flex overflow-x-auto no-scrollbar px-4 gap-3 pb-2" data-id="element-344">
            {TRENDING_HASHTAGS.map(tag => <button key={tag} onClick={() => navigate(`/hashtag/${tag}`)} className="bg-surface border border-border px-5 py-2 rounded-full text-white text-sm font-medium whitespace-nowrap hover:bg-surface2 transition-colors" data-id="element-345">
                #{tag}
              </button>)}
          </div>
        </div>

        {/* Popular Creators */}
        <div className="mb-8" data-id="element-346">
          <h2 className="px-4 text-white font-poppins font-bold text-lg mb-4" data-id="element-347">
            Popular Creators
          </h2>
          <div className="flex overflow-x-auto no-scrollbar px-4 gap-4 pb-2" data-id="element-348">
            {MOCK_USERS.map(user => <button key={user.id} onClick={() => navigate('/profile')} className="bg-surface border border-border rounded-2xl p-4 flex flex-col items-center min-w-[140px] shrink-0 hover:bg-surface2 transition-colors text-left" data-id="element-349">
                <Avatar src={user.avatar} size="lg" className="mb-3" data-id="element-350" />
                <span className="text-white font-bold text-sm truncate w-full text-center" data-id="element-351">
                  {user.name}
                </span>
                <span className="text-softGray text-xs mb-3" data-id="element-352">
                  @{user.username}
                </span>
                <span onClick={e => {
              e.stopPropagation();
            }} className="w-full bg-primary text-black font-bold text-xs py-2 rounded-full hover:bg-primary/90 transition-colors text-center" data-id="element-353">
                  Follow
                </span>
              </button>)}
          </div>
        </div>

        {/* Categories */}
        <div className="mb-8" data-id="element-354">
          <h2 className="px-4 text-white font-poppins font-bold text-lg mb-4" data-id="element-355">
            Categories
          </h2>
          <div className="grid grid-cols-2 gap-3 px-4" data-id="element-356">
            {MOCK_CATEGORIES.map(cat => <button key={cat.name} onClick={() => navigate(`/search/results?q=${encodeURIComponent(cat.name)}`)} className="bg-surface border border-border rounded-xl p-4 flex items-center gap-3 hover:bg-surface2 transition-colors cursor-pointer text-left" data-id="element-357">
                <span className="text-2xl" data-id="element-358">{cat.emoji}</span>
                <span className="text-white font-medium text-sm" data-id="element-359">
                  {cat.name}
                </span>
              </button>)}
          </div>
        </div>

        {/* Featured Videos */}
        <div data-id="element-360">
          <h2 className="px-4 text-white font-poppins font-bold text-lg mb-4" data-id="element-361">
            Featured Videos
          </h2>
          <div className="grid grid-cols-2 gap-1 px-1" data-id="element-362">
            {MOCK_VIDEOS.map(video => <button key={video.id} onClick={() => navigate('/feed')} className="relative aspect-[3/4] bg-surface rounded-md overflow-hidden cursor-pointer group text-left" data-id="element-363">
                <div className={`absolute inset-0 bg-gradient-to-br ${video.color} opacity-80 group-hover:scale-105 transition-transform duration-500`} data-id="element-364" />
                <div className="absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/80 to-transparent" data-id="element-365">
                  <div className="flex items-center gap-1.5 mb-1" data-id="element-366">
                    <Avatar src={video.user.avatar} size="sm" className="w-5 h-5" data-id="element-367" />
                    <span className="text-white text-[10px] font-medium truncate" data-id="element-368">
                      {video.user.username}
                    </span>
                  </div>
                  <p className="text-white/90 text-[10px] line-clamp-2 leading-tight" data-id="element-369">
                    {video.caption}
                  </p>
                </div>
              </button>)}
          </div>
        </div>
      </div>
    </div>;
}